import {Component, ElementRef, Injector, OnInit, ViewChild} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {GetServicesService} from '../../../core/services/config/estrutura/get-services.service';

@Component({
  selector: 'app-form-autocomplete',
  templateUrl: './form-autocomplete.component.html'
})

export class FormAutocompleteComponent implements OnInit {
  config;
  grupo: FormGroup;
  opcoesFiltradas: Observable<any[]>;
  @ViewChild('input') input: ElementRef;
  @ViewChild('auto') auto: ElementRef;
  selected;
  private service;
  serviceInject;
  filteredLength;
  max = 20;
  isOpened;
  loaded = false;

// , {
//   nome: 'loja',
//   editorTipo: 'autocomplete',
//   editorOpcoes: {
//     placeholder: 'Loja',
//     value: '',
//     obrigatorio: true,
//     valueExpr: 'id',
//     displayExpr: 'nome',
//     opcoesFrom: 'lojas',
//     opcoesParam: null,
//     alinhamento: true
//   },
//   width: 25
// },

  constructor(private injector: Injector, private _getServices: GetServicesService) {
  }

  importService() {
    if (this.config.editorOpcoes.opcoesFrom) {
      let service = this.config.editorOpcoes.opcoesFrom.charAt(0).toUpperCase() + this.config.editorOpcoes.opcoesFrom.slice(1) + 'Service';
      const indexHifen = service.indexOf('-');
      if (indexHifen !== -1) {
        service = service.substring(0, indexHifen) +
          this.config.editorOpcoes.opcoesFrom.charAt(indexHifen + 1).toUpperCase() +
          service.substring(indexHifen + 2, service.length);
      }
      this._getServices.getLocalServices().subscribe((services) => {
          const index = services.findIndex((serviceItem) => serviceItem.nome === this.config.editorOpcoes.opcoesFrom);
          if (index !== -1) {
            import
            ('../../../core/services/' + this.config.editorOpcoes.opcoesFrom + '.service').then(module => {

              this.service = module[service];
              this.getService();
              // this.serviceInject['get' + this.config.editorOpcoes.opcoesFrom.charAt(0).toUpperCase() + this.config.editorOpcoes.opcoesFrom.slice(1) + 'Storage']().subscribe(data => {
              //   if (data) {
              //     this.config.opcoes = data;
              //             } else {
              let get;
              if (!this.config.editorOpcoes.metodo) {
                get = 'get' + this.config.editorOpcoes.opcoesFrom.charAt(0).toUpperCase() + this.config.editorOpcoes.opcoesFrom.slice(1);
              } else {
                get = this.config.editorOpcoes.metodo;
              }
              this.serviceInject[get](this.config.editorOpcoes.opcoesParam).subscribe(opcoes => {
                this.config.editorOpcoes.opcoes = opcoes;
                this.loaded = true;
                if (this.config.editorOpcoes.tipoFiltro) {
                  this.initFiltered();
                } else {
                  this.opcoesFiltradas = opcoes;
                }
              });
              //             }
              if (this.grupo.controls[this.config.nome].valueChanges) {
                if (this.grupo.controls[this.config.nome]['value']) {
                  this.checkValidValue(this.grupo.controls[this.config.nome]['value']);
                }
              }
            });
          } else {
            import
            ('../../../core/services/documentos-json.service').then(moduleDoc => {
              this.service = moduleDoc['DocumentosJsonService'];
              this.getService();
              this.serviceInject['getDocumentoNomeEmpresa'](0, this.config.editorOpcoes.opcoesFrom).subscribe(opcoes => {
                this.config.editorOpcoes.opcoes = opcoes['documento_json'];
                this.loaded = true;
                if (this.config.editorOpcoes.tipoFiltro) {
                  this.initFiltered();
                } else {
                  this.opcoesFiltradas = opcoes['documento_json'];
                }
              });
            });
          }
        }
      );
      //             });
    } else {
      this.loaded = true;
    }
  }

  getService() {
    if (typeof this.serviceInject === 'undefined') {
      this.serviceInject = this.injector.get(this.service);
    }
    return this.serviceInject;
  }

  filterOptions(name: string) {
    const filtered = this.config.editorOpcoes.opcoes.filter(option =>
      option.toLowerCase().indexOf(name.toLowerCase()) === 0);
    this.filteredLength = filtered.length;
    return filtered;
  }

  filterAnyPosition(value) {
    const filterValue = value.toLowerCase();
    const filtered = this.config.editorOpcoes.opcoes.filter(option => option.toLowerCase().includes(filterValue));
    this.filteredLength = filtered.length;
    return filtered;
  }

// optionSelected(event) {
//   this.selected = event.option.value;
// }

  displayFn(val) {
    if (!val) {
      return null;
    }

    if (this.config.editorOpcoes.opcoes) {
      const index = this.config.editorOpcoes.opcoes.findIndex(opcao => opcao[this.config.editorOpcoes.valueExpr] === val);
      return this.config.editorOpcoes.opcoes[index][this.config.editorOpcoes.displayExpr];
    }
  }

  clearInput() {
    const component = this;
    setTimeout(function () {
      component.isOpened = false;
    }, 300);
  }

  initFiltered() {
    if (this.config.editorOpcoes.opcoes && this.config.editorOpcoes.opcoes.length) {
      this.filteredLength = this.config.editorOpcoes.opcoes.length;
      this.opcoesFiltradas = this.grupo.controls[this.config.nome].valueChanges
        .pipe(
          startWith(''),
          map(option => option ? this.getFilter(option) : this.config.editorOpcoes.opcoes.slice()
          ));
    }
  }

  getFilter(option) {
    this.max = 20;
    switch (this.config.editorOpcoes.tipoFiltro) {
      case undefined: {
        return this.filterOptions(option);
      }
      case 'qualquerPosicao': {
        return this.filterAnyPosition(option);
      }
    }
  }

  showMore() {
    if (this.filteredLength - 20 >= this.max) {
      return this.max = this.max + 20;
    } else {
      return this.max = this.filteredLength;
    }
  }

  checkValidValue(value) {
    if (this.config.editorOpcoes.opcoes && this.config.editorOpcoes.opcoes.indexOf(value) === -1) {
      this.input.nativeElement.value = null;
      this.grupo.controls[this.config.nome].setValue(null);
    }
  }

  importService2() {
    return new Promise((resolve, reject) => {
      import
      ('../../../core/services/lojas.service' + '').then(module => {
        this.service = module['LojasService'];
        const service = this.getService();
        resolve(service);
      });
    });
  }

  ngOnInit() {
    // this.importService2().then((res) => {
    //   if (res) {
    //     console.log(res);
    //   }
    // });
    this.importService();
    if (this.config.editorOpcoes.tipoFiltro) {
      this.initFiltered();
    }
    if (this.grupo.controls[this.config.nome].valueChanges) {
      if (this.config.editorOpcoes.opcoes && this.grupo.controls[this.config.nome]['value']) {
        this.checkValidValue(this.grupo.controls[this.config.nome]['value']);
      }
    }
  }
}
